import script from "./educacion_experiencia_lab.vue?vue&type=script&setup=true&lang=js"
export * from "./educacion_experiencia_lab.vue?vue&type=script&setup=true&lang=js"

import "./educacion_experiencia_lab.vue?vue&type=style&index=0&id=5c76fd8f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c76fd8f"]])

export default __exports__